module.exports = __webpack_public_path__ + "img/1F613.c9075b46.svg";